export default [
  "https://ptclient.mkgest.com/app/2/logo.jpg",
  "https://ptclient.mkgest.com/app/3/logo.jpg",
  "https://ptclient.mkgest.com/app/4/logo.jpg",
  "https://ptclient.mkgest.com/app/5/logo.jpg",
  "https://ptclient.mkgest.com/app/7/logo.jpg",
  "https://ptclient.mkgest.com/app/8/logo.jpg",
  "https://ptclient.mkgest.com/app/9/logo.jpg",
  "https://ptclient.mkgest.com/app/10/logo.jpg",
  "https://ptclient.mkgest.com/app/13/logo.jpg",
  "https://ptclient.mkgest.com/app/14/logo.jpg",
  "https://ptclient.mkgest.com/app/15/logo.jpg",
  "https://ptclient.mkgest.com/app/16/logo.jpg",
  "https://ptclient.mkgest.com/app/18/logo.jpg",
  "https://ptclient.mkgest.com/app/19/logo.jpg",
  "https://ptclient.mkgest.com/app/20/logo.jpg",
  "https://ptclient.mkgest.com/app/21/logo.jpg",
  "https://ptclient.mkgest.com/app/22/logo.jpg",
  "https://ptclient.mkgest.com/app/23/logo.jpg",
  "https://ptclient.mkgest.com/app/24/logo.jpg",
  "https://ptclient.mkgest.com/app/26/logo.jpg",
  "https://ptclient.mkgest.com/app/27/logo.jpg",
  "https://ptclient.mkgest.com/app/28/logo.jpg",
  "https://ptclient.mkgest.com/app/30/logo.jpg",
  "https://ptclient.mkgest.com/app/32/logo.jpg",
  "https://ptclient.mkgest.com/app/33/logo.jpg",
  "https://ptclient.mkgest.com/app/35/logo.jpg",
  "https://ptclient.mkgest.com/app/36/logo.jpg",
  "https://ptclient.mkgest.com/app/37/logo.jpg",
  "https://ptclient.mkgest.com/app/38/logo.jpg",
  "https://ptclient.mkgest.com/app/39/logo.jpg",
  "https://ptclient.mkgest.com/app/40/logo.jpg",
  "https://ptclient.mkgest.com/app/41/logo.jpg",
  "https://ptclient.mkgest.com/app/42/logo.jpg",
  "https://ptclient.mkgest.com/app/43/logo.jpg",
  "https://ptclient.mkgest.com/app/44/logo.jpg",
  "https://ptclient.mkgest.com/app/45/logo.jpg",
  "https://ptclient.mkgest.com/app/46/logo.jpg",
  "https://ptclient.mkgest.com/app/47/logo.jpg",
  "https://ptclient.mkgest.com/app/48/logo.jpg",
  "https://ptclient.mkgest.com/app/49/logo.jpg",
  "https://ptclient.mkgest.com/app/50/logo.jpg",
  "https://ptclient.mkgest.com/app/51/logo.jpg",
];